// useAuth.ts
import { useState, useEffect } from 'react';

const useAuth = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const token = sessionStorage.getItem('authToken');
        const refreshToken = sessionStorage.getItem('refreshToken');
        setIsAuthenticated(!!token && !!refreshToken);
    }, []);

    return isAuthenticated;
};

export default useAuth;
